import React, { useState, useEffect } from "react";
import styled, { keyframes } from "styled-components";

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const slideInLeft = keyframes`
  from {
    opacity: 0;
    transform: translateX(-50px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`;

const LocationPage = styled.div`
  display: flex;
  flex-direction: row;
  min-height: 90vh;
  background: linear-gradient(to right, #d28710 0%, #f39c12 100%);
  background-color: ${(props) => (props.isScrolled ? "#d28710 " : "#f39c12")};
  color: #fff;
  transition: background-color 0.3s ease;

  @media (max-width: 768px) {
    flex-direction: column;
    min-height: 80vh; 
  }

  @media (max-width: 480px) {
    min-height: 80vh; 
    width: 100%;
  }
`;

const AddressContainer = styled.div`
  flex: 1;
  padding: 30px;
    background: linear-gradient(to right, #d28710 0%, #f39c12 100%);
  display: flex;
  flex-direction: column;
  justify-content: center;
  animation: ${slideInLeft} 1s ease-in-out;

  @media (max-width: 768px) {
    padding: 20px;
  }

  @media (max-width: 480px) {
    padding: 15px;
    text-align: center;
  }
`;

const Title = styled.h1`
font-size: 3.6rem;
  color: #ffffff;
  font-weight: 700;
  margin-bottom: 20px;
  animation: ${fadeIn} 1.5s ease-in-out;

  @media (max-width: 768px) {
    font-size: 2rem;
  }

  @media (max-width: 480px) {
    font-size: 3rem;
  }
`;

const Description = styled.p`
  font-size: 1.7rem;
  color: #fff;
  line-height: 1.8;
  animation: ${fadeIn} 1.5s ease-in-out;

  @media (max-width: 768px) {
    font-size: 1.5rem;
  }

  @media (max-width: 480px) {
    font-size: 1.4rem;
    line-height: 1.8rem;
  }
`;

const MapContainer = styled.div`
  flex: 1;
  position: relative;
   background-color: #f59d12;
  animation: ${fadeIn} 1.5s ease-in-out;
  display: flex;
  justify-content: center;
  align-items: center;

  iframe {
    width: 90%;
    height: 90%;
    border: none;

    @media (max-width: 768px) {
      height: 60%;
      width: 90%;
    }

    @media (max-width: 480px) {
      height: 60%;
      width: 90%;
    }
  }
`;

const Location = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  const handleScroll = () => {
    if (window.scrollY > 50) {
      setIsScrolled(true);
    } else {
      setIsScrolled(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <LocationPage isScrolled={isScrolled} id="location">
      <AddressContainer>
        <Title>LOCATION ADVANTAGE</Title>
        <Description>
          Experience the best of urban living, where top-notch schools,
          hospitals, hotels, shopping, dining, and entertainment are just
          moments away, ensuring not only convenience but also a valuable
          investment in a thriving location.
          <br />
          <br />
          <strong>Legacy School</strong> - 3.8 km
          <br />
          <strong>Specialist Hospital</strong> - 7 km
          <br />
          <strong>Leela Bhartiya City</strong> - 7 km
          <br />
          <strong>Bangalore International School</strong> - 4.7 km
          <br />
          <strong>Decathlon</strong> - 4.3 km
          <br />
          <strong>Columbia Asia Hospital</strong> - 13.7 km
          <br />
          <strong>Courtyard by Marriott</strong> - 9.7 km
          <br />
          <strong>Elements Mall</strong> - 8.6 km
        </Description>
      </AddressContainer>
      <MapContainer>
  <iframe
    title="Google Map"
    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3887.772479998767!2d77.6824748!3d13.2639683!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bb1e325cc924851%3A0x89cceaf16d148be7!2sTangled%20up%20in%20Green%20-%20Total%20Environment!5e0!3m2!1sen!2sin!4v1703325862608"
    allowFullScreen
    loading="lazy"
  ></iframe>
</MapContainer>



    </LocationPage>
  );
};

export default Location;
